const showBanner = () => {
    $('.nautilus-banner').show();
    $('.nautilus-logo').hide();
};

const hideBanner = () => {
    $('.nautilus-banner').hide();
    $('.nautilus-logo').show();
};

export const initSiteBannerControl = () => {
    $(document).on('collapsed.lte.pushmenu', hideBanner);
    $(document).on('shown.lte.pushmenu', showBanner);

    $('.main-sidebar').on('mouseenter', () => {
        if ($('body').hasClass('sidebar-collapse')) {
            showBanner();
        }
    });
    $('.main-sidebar').on('mouseleave', () => {
        if ($('body').hasClass('sidebar-collapse')) {
            hideBanner();
        }
    });
};
